import { IPolicyElement } from './IPolicyElement';
import { PolicyElement } from './PolicyElement';

/**
 * A Policy is a group of related PolicyElements (the same key start).
 * A Policy implements IPolicyElement for two reasons:
 * * When applying and resetting policies, a service can treat a Policy the same as a PolicyElement (it can be applied and reset)
 * * Each Policy can then handle the application and resetting of it's own PolicyElements
 */
export abstract class Policy implements IPolicyElement {
  abstract readonly keyStart: RegExp;
  policyElements: PolicyElement[] = [];

  /**
   * Applies a policy element to this policy. Removes the key start and searches for policy elements that match.
   * @param key The policy element name/key
   * @returns Whether the policy element was applied to this policy
   */
  apply(key: string): boolean {
    const trimmedKey = key.replace(this.keyStart, '');
    return this.policyElements.some((policyElement) =>
      policyElement.apply(trimmedKey),
    );
  }

  reset() {
    this.policyElements.forEach((policyElement) => {
      policyElement.reset();
    });
  }
}
